/**
 * This plugin ensures that the editor structure is never empty, we always
 * want it to at least have an empty paragraph.
 */

import type { EditorPlugin } from '../../types/aha-editor';
import { Editor, Transforms, type NodeEntry } from 'slate';
import emptyParagraph from '../../AhaEditorUtils/util/emptyParagraph';

const NeverEmptyPlugin: EditorPlugin = {
  name: 'Never empty plugin',
  normalization: {
    check: (_: Editor, [node]: NodeEntry) => {
      return Editor.isEditor(node) && node.children.length === 0;
    },
    run: (editor: Editor, _: NodeEntry) => {
      Transforms.insertNodes(editor, emptyParagraph());

      return true;
    },
  },
};

export default NeverEmptyPlugin;
